/**
 * Strips HTML tags and decodes common HTML entities from a string.
 * Useful for generating clean text for schema.org structured data.
 *
 * @param html - The HTML string to process
 * @returns Clean text with HTML tags removed and entities decoded
 */
export function stripHtmlForSchema(html: string | null | undefined): string {
    if (!html) return "";

    // Remove HTML tags
    let text = html.replace(/<[^>]*>/g, "");

    // Decode common HTML entities
    const entities: Record<string, string> = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
        "&nbsp;": " ",
    };

    for (const [entity, char] of Object.entries(entities)) {
        text = text.replace(new RegExp(entity, "g"), char);
    }

    // Normalise whitespace
    return text.replace(/\s+/g, " ").trim();
}
